import React from 'react';
import PropTypes from 'prop-types';
import { scroller } from 'react-scroll';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';
import { PRICE_CHECKER_NAME } from 'site-modules/shared/constants/price-checker';
import { ENTER_KEY_VALUE } from 'site-modules/shared/constants/key-values';

const SCROLL_CONFIG = {
  duration: 300,
  offset: -105,
  smooth: true,
  spy: true,
};

export function PriceCheckerAnchorLink({ type = '', children = null, scrollLinkClasses = '' }) {
  function handleKeyPress({ key }) {
    if (key === ENTER_KEY_VALUE) {
      scroller.scrollTo(PRICE_CHECKER_NAME, SCROLL_CONFIG);
    }
  }

  return (
    <ScrollLink
      aria-label="Pricing Details"
      to={PRICE_CHECKER_NAME}
      onKeyPress={handleKeyPress}
      tabIndex={0}
      data-tracking-id="view_content"
      data-tracking-value={`${type.toLowerCase()} price`}
      scrollConfig={SCROLL_CONFIG}
      className={scrollLinkClasses}
    >
      {children}
    </ScrollLink>
  );
}

PriceCheckerAnchorLink.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node,
  scrollLinkClasses: PropTypes.string,
};
